var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapMarkers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16s6-6.065 6-9.6C14 2.865 11.314 0 8 0S2 2.865 2 6.4 8 16 8 16zm0-7a3 3 0 100-6 3 3 0 000 6z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDE2QzggMTYgMTQgOS45MzQ2MiAxNCA2LjRDMTQgMi44NjUzOCAxMS4zMTM3IDAgOCAwQzQuNjg2MjggMCAyIDIuODY1MzggMiA2LjRDMiA5LjkzNDYyIDggMTYgOCAxNlpNOCA5QzkuNjU2ODYgOSAxMSA3LjY1Njg1IDExIDZDMTEgNC4zNDMxNSA5LjY1Njg2IDMgOCAzQzYuMzQzMTQgMyA1IDQuMzQzMTUgNSA2QzUgNy42NTY4NSA2LjM0MzE0IDkgOCA5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgMapMarkers as ReactComponent };